/* ============================================================
   PURETREX — PDP v2 buy box
   Purchase mode, quantity, live pricing, sticky bar, gallery.
   No dependencies.
   ============================================================ */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  function perDay(cents, days) {
    if (!days) return '';
    return '$' + (cents / 100 / days).toFixed(2) + '/day';
  }

  function init(root) {
    if (!root || root.__ptx2) return;
    root.__ptx2 = true;

    var holder = root.querySelector('[data-ptx2-data]');
    var d;
    try { d = JSON.parse(holder.textContent); }
    catch (e) { if (window.console) console.warn('PTX v2: bad price payload', e); return; }

    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    var qtyField  = root.querySelector('[data-ptx2-qtyfield]');
    var planField = root.querySelector('[data-ptx2-planfield]');
    var opts      = [].slice.call(root.querySelectorAll('[data-ptx2-opt]'));
    var tiers     = [].slice.call(root.querySelectorAll('[data-ptx2-tier]'));
    var freqs     = [].slice.call(root.querySelectorAll('[data-ptx2-freq]'));
    var atcText   = root.querySelector('[data-ptx2-atctext]');

    /* Match the section's preferred delivery frequency by name, so a
       60-day pouch defaults to the two-monthly plan rather than the
       first one Appstle happens to return. */
    function preferredPlan() {
      if (!d.plans || !d.plans.length) return null;
      var want = String(d.preferredPlan || '').toLowerCase().trim();
      if (want) {
        for (var i = 0; i < d.plans.length; i++) {
          if (String(d.plans[i].name || '').toLowerCase().indexOf(want) !== -1) return d.plans[i];
        }
      }
      return d.plans[0];
    }

    var plan = preferredPlan();
    var state = { mode: 'one', tier: 0 };

    function planById(id) {
      for (var i = 0; i < (d.plans || []).length; i++) {
        if (String(d.plans[i].id) === String(id)) return d.plans[i];
      }
      return null;
    }
    function pctOff(pl) {
      if (!pl || !d.base) return 0;
      return Math.round((1 - pl.price / d.base) * 100);
    }
    /* A readable delivery label from the Appstle plan name:
       "Month" -> "every month", "2 Months" -> "every 2 months". */
    function plural(word, n) {
      if (n === 1) return word;
      var w = String(word || 'pouch');
      return /(ch|sh|s|x|z)$/i.test(w) ? w + 'es' : w + 's';
    }
    function everyLabel(pl) {
      var n = String(pl && pl.name || '').trim().toLowerCase();
      if (!n) return '';
      return 'every ' + n;
    }

    /* Tier facts live on the markup, so the theme editor stays the single
       source of truth for quantity and discount. */
    function tierAt(i) {
      var el = tiers[i];
      if (!el) return { qty: 1, pct: 0 };
      return {
        qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
        pct: parseInt(el.getAttribute('data-pct'), 10) || 0
      };
    }
    function current() { return tierAt(state.tier); }

    function unit() {
      return (state.mode === 'sub' && plan) ? plan.price : d.base;
    }
    /* A quantity discount applies to one-time orders only. Subscription
       pricing is whatever the Appstle plan charges, never stacked. */
    function priceFor(qty, pct) {
      var gross = unit() * qty;
      if (state.mode === 'sub' || !pct) return gross;
      return gross - Math.round(gross * pct / 100);
    }
    function total() {
      var t = current();
      return priceFor(t.qty, t.pct);
    }

    function render() {
      var cur = current();
      if (qtyField) qtyField.value = cur.qty;
      if (planField) planField.value = (state.mode === 'sub' && plan) ? plan.id : '';

      opts.forEach(function (o) {
        var on = o.getAttribute('data-ptx2-opt') === state.mode;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      /* Both option cards price the quantity the customer actually picked,
         so the two lines compare like with like. */
      var oneNet = d.base * cur.qty;
      if (cur.pct) oneNet = oneNet - Math.round(oneNet * cur.pct / 100);
      var oneEl = root.querySelector('[data-ptx2-price-one]');
      if (oneEl) oneEl.textContent = money(oneNet, fmt);

      if (plan) {
        var subEl = root.querySelector('[data-ptx2-price-sub]');
        if (subEl) subEl.textContent = money(plan.price * cur.qty, fmt);
        var wasEl = root.querySelector('[data-ptx2-was-sub]');
        if (wasEl) wasEl.textContent = plan.price < d.base ? money(d.base * cur.qty, fmt) : '';
        var pill = root.querySelector('[data-ptx2-pill]');
        if (pill) {
          var off = pctOff(plan);
          pill.textContent = off > 0 ? ('SAVE ' + off + '%') : '';
          pill.style.display = off > 0 ? '' : 'none';
        }
        var subMeta = root.querySelector('[data-ptx2-meta-sub]');
        if (subMeta && d.days) {
          var note = document.createElement('span');
          note.textContent = 'Delivered ' + everyLabel(plan);
          var pd = document.createElement('span');
          pd.className = 'nw';
          pd.textContent = '\u00b7 ' + perDay(plan.price * cur.qty, d.days * cur.qty);
          subMeta.textContent = '';
          subMeta.appendChild(note);
          subMeta.appendChild(document.createTextNode(' '));
          subMeta.appendChild(pd);
        }
      }

      freqs.forEach(function (f) {
        var pl = planById(f.getAttribute('data-ptx2-freq'));
        var on = plan && String(pl && pl.id) === String(plan.id);
        f.classList.toggle('is-active', !!on);
        f.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      tiers.forEach(function (el, i) {
        var on = i === state.tier;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      /* Quantity meta: supply length, plus the saving once a real
         quantity discount is set (one-time only, never stacked). */
      var qm = root.querySelector('[data-ptx2-qtymeta]');
      if (qm) {
        var parts = [];
        if (d.days) parts.push((d.days * cur.qty) + '-day supply');
        if (state.mode !== 'sub' && cur.pct > 0) {
          var g = d.base * cur.qty;
          parts.push('Save ' + money(g - priceFor(cur.qty, cur.pct), fmt));
        }
        qm.textContent = parts.join(' \u00b7 ');
      }

      var more = root.querySelector('[data-ptx2-submore]');
      if (more) more.hidden = state.mode !== 'sub';

      if (atcText) {
        atcText.textContent = (d.atcLabel || 'Add to cart') + ' · ' + money(total(), fmt);
      }
      var pdEl = root.querySelector('[data-ptx2-perday]');
      if (pdEl && d.days) pdEl.textContent = perDay(total(), d.days * cur.qty);
      [].slice.call(document.querySelectorAll('[data-ptx2-remote-price]')).forEach(function (el) {
        el.textContent = '\u00b7 ' + money(total(), fmt);
      });
      var sp = document.querySelector('[data-ptx2-sticky-price]');
      if (sp) {
        sp.textContent = money(total(), fmt) + (d.days ? (' · ' + (d.days * cur.qty) + ' days') : '');
      }
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        state.mode = o.getAttribute('data-ptx2-opt');
        render();
      });
    });
    function pickTier(i) { state.tier = i; render(); }
    freqs.forEach(function (f) {
      f.addEventListener('click', function (e) {
        e.stopPropagation();
        var pl = planById(f.getAttribute('data-ptx2-freq'));
        if (!pl) return;
        plan = pl;
        state.mode = 'sub';
        render();
      });
    });
    tiers.forEach(function (el, i) {
      el.addEventListener('click', function () { pickTier(i); });
      el.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pickTier(i); }
      });
    });

    render();

    /* gallery */
    var stage = root.querySelector('[data-ptx2-stage]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-ptx2-thumb]'));
    if (stage && thumbs.length) {
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          var slide = stage.children[i];
          if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          thumbs.forEach(function (o, j) { o.classList.toggle('is-active', j === i); });
        });
      });
      // a tap in the gaps around the thumbs picks the nearest one
      thumbs[0].parentNode.addEventListener('click', function (e) {
        if (e.target.closest('[data-ptx2-thumb]')) return;
        var best = null, bestD = Infinity;
        thumbs.forEach(function (t) {
          var r = t.getBoundingClientRect();
          var d = Math.abs(e.clientX - (r.left + r.width / 2));
          if (d < bestD) { bestD = d; best = t; }
        });
        if (best) best.click();
      });
      var timer = null;
      stage.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var idx = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth));
          thumbs.forEach(function (o, j) { o.classList.toggle('is-active', j === idx); });
        }, 80);
      }, { passive: true });
    }
    try { initZoom(root, stage); }
    catch (e) { if (window.console) console.warn('PTX v2: zoom failed', e); }

    /* stars: scroll to the reviews, below the sticky header */
    var toReviews = root.querySelector('[data-ptx2-toreviews]');
    if (toReviews) {
      toReviews.addEventListener('click', function (e) {
        var target = document.getElementById('judgeme_product_reviews');
        if (!target) return;
        e.preventDefault();
        var sec = target.closest('.shopify-section') || target;
        var head = document.querySelector('.section-header');
        var off = head ? head.offsetHeight : 0;
        window.scrollTo({ top: sec.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
      });
    }

    /* Sticky bar shows once the real button has scrolled above the viewport.
       On phones it also shows before the visitor reaches the button, i.e.
       whenever the button isn't on screen, so Add to cart is visible from
       first load. A scroll listener throttled to one frame is used instead of an
       IntersectionObserver: an observer only reports state *changes*, so a
       fast fling that jumps the button straight from below the fold to above
       it never fires, and the bar would stay hidden. */
    var bar = document.querySelector('[data-ptx2-sticky]');
    var atc = root.querySelector('[data-ptx2-atc]');
    if (bar && atc) {
      var ticking = false;
      var lastShow = null;
      function checkBar() {
        ticking = false;
        var r = atc.getBoundingClientRect();
        var show = window.innerWidth < 750
          ? !(r.top < window.innerHeight && r.bottom > 0)
          : r.bottom < 0;
        if (show !== lastShow) {
          lastShow = show;
          bar.classList.toggle('is-on', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(checkBar); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('load', onScroll);
      checkBar();
    }
    var barBtn = bar && bar.querySelector('[data-ptx2-stickybtn]');
    if (barBtn && atc) {
      barBtn.addEventListener('click', function () {
        var form = atc.form || root.querySelector('form');
        if (form && form.requestSubmit) form.requestSubmit(atc);
        else atc.click();
      });
    }
  }

  /* ------------------------------------------------------------
     Image zoom. Tapping a gallery image opens it full screen.
     In the viewer a click / tap zooms in at that point; on desktop
     the zoomed image follows the mouse, on touch it is dragged with
     one finger or pinched with two. Swipe or arrows change image.
     One viewer is built per page and shared by every buy box.
     ------------------------------------------------------------ */
  var lb = null;

  function buildViewer() {
    var el = document.createElement('div');
    el.className = 'ptx2 ptx2-lb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image viewer');
    el.hidden = true;
    el.innerHTML =
      '<div class="ptx2-lb__view" data-lb-view><img class="ptx2-lb__img" alt="" draggable="false" data-lb-img></div>' +
      '<button type="button" class="ptx2-lb__btn ptx2-lb__close" aria-label="Close" data-lb-close>' +
        '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="ptx2-lb__btn ptx2-lb__nav ptx2-lb__nav--prev" aria-label="Previous image" data-lb-prev>' +
        '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="ptx2-lb__btn ptx2-lb__nav ptx2-lb__nav--next" aria-label="Next image" data-lb-next>' +
        '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<p class="ptx2-lb__count" data-lb-count></p>';
    document.body.appendChild(el);

    var view = el.querySelector('[data-lb-view]');
    var img = el.querySelector('[data-lb-img]');
    var count = el.querySelector('[data-lb-count]');
    var MAX = 4, TAP_ZOOM = 2.5;
    var v = {
      items: [], idx: 0, onClose: null, opener: null,
      scale: 1, ox: 50, oy: 50,
      touch: null, moved: false
    };

    function apply() {
      img.style.transformOrigin = v.ox + '% ' + v.oy + '%';
      img.style.transform = v.scale > 1 ? 'scale(' + v.scale + ')' : '';
      el.classList.toggle('is-zoomed', v.scale > 1);
    }
    function reset() { v.scale = 1; v.ox = 50; v.oy = 50; apply(); }
    function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
    function pct(x, y) {
      var r = img.getBoundingClientRect();
      // the rect is already scaled, so this maps straight to image percent
      return { x: clamp((x - r.left) / r.width * 100, 0, 100), y: clamp((y - r.top) / r.height * 100, 0, 100) };
    }

    function show(i) {
      var n = v.items.length;
      v.idx = (i + n) % n;
      var it = v.items[v.idx];
      reset();
      img.src = it.small;
      img.alt = it.alt;
      if (it.big && it.big !== it.small) {
        var want = v.idx, pre = new Image();
        pre.onload = function () { if (v.idx === want && !el.hidden) img.src = it.big; };
        pre.src = it.big;
      }
      count.textContent = n > 1 ? (v.idx + 1) + ' / ' + n : '';
      el.classList.toggle('is-single', n < 2);
    }

    function open(items, i, onClose, opener) {
      v.items = items; v.onClose = onClose; v.opener = opener || null;
      el.hidden = false;
      document.documentElement.classList.add('ptx2-lb-open');
      show(i);
      el.querySelector('[data-lb-close]').focus({ preventScroll: true });
    }
    function close() {
      if (el.hidden) return;
      el.hidden = true;
      document.documentElement.classList.remove('ptx2-lb-open');
      reset();
      if (v.onClose) v.onClose(v.idx);
      if (v.opener) v.opener.focus({ preventScroll: true });
    }

    el.querySelector('[data-lb-close]').addEventListener('click', close);
    el.querySelector('[data-lb-prev]').addEventListener('click', function () { show(v.idx - 1); });
    el.querySelector('[data-lb-next]').addEventListener('click', function () { show(v.idx + 1); });
    document.addEventListener('keydown', function (e) {
      if (el.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(v.idx - 1);
      else if (e.key === 'ArrowRight') show(v.idx + 1);
    });

    /* click / tap: zoom in at the point, or back out */
    view.addEventListener('click', function (e) {
      if (v.moved) { v.moved = false; return; }
      if (e.target !== img) { if (v.scale === 1) close(); else reset(); return; }
      if (v.scale > 1) { reset(); return; }
      var p = pct(e.clientX, e.clientY);
      v.ox = p.x; v.oy = p.y; v.scale = TAP_ZOOM; apply();
    });

    /* desktop: zoomed image follows the mouse */
    view.addEventListener('mousemove', function (e) {
      if (v.scale === 1 || v.touch) return;
      var r = view.getBoundingClientRect();
      v.ox = clamp((e.clientX - r.left) / r.width * 100, 0, 100);
      v.oy = clamp((e.clientY - r.top) / r.height * 100, 0, 100);
      apply();
    });

    /* touch: one finger drags (or swipes when not zoomed), two pinch */
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    view.addEventListener('touchstart', function (e) {
      var t = e.touches;
      v.moved = false;
      if (t.length === 2) {
        var mid = pct((t[0].clientX + t[1].clientX) / 2, (t[0].clientY + t[1].clientY) / 2);
        if (v.scale === 1) { v.ox = mid.x; v.oy = mid.y; }
        v.touch = { pinch: true, d: dist(t), s: v.scale };
      } else if (t.length === 1) {
        v.touch = { x: t[0].clientX, y: t[0].clientY, ox: v.ox, oy: v.oy };
      }
      el.classList.add('is-dragging');
    }, { passive: true });
    view.addEventListener('touchmove', function (e) {
      var t = e.touches, s = v.touch;
      if (!s) return;
      if (s.pinch && t.length === 2) {
        e.preventDefault();
        v.scale = clamp(s.s * dist(t) / s.d, 1, MAX);
        v.moved = true;
        apply();
      } else if (!s.pinch && t.length === 1) {
        var dx = t[0].clientX - s.x, dy = t[0].clientY - s.y;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) v.moved = true;
        if (v.scale > 1) {
          e.preventDefault();
          var r = img.getBoundingClientRect(), k = v.scale / (v.scale - 1);
          // moving the origin against the finger keeps the touched point under it
          v.ox = clamp(s.ox - dx / r.width * 100 * k, 0, 100);
          v.oy = clamp(s.oy - dy / r.height * 100 * k, 0, 100);
          apply();
        }
      }
    }, { passive: false });
    view.addEventListener('touchend', function (e) {
      var s = v.touch;
      if (e.touches.length) return;
      el.classList.remove('is-dragging');
      v.touch = null;
      if (!s) return;
      if (s.pinch) { if (v.scale < 1.1) reset(); return; }
      if (v.scale === 1 && v.items.length > 1) {
        var dx = e.changedTouches[0].clientX - s.x, dy = e.changedTouches[0].clientY - s.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(v.idx + (dx < 0 ? 1 : -1));
        else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
      }
    });

    return { open: open };
  }

  function initZoom(root, stage) {
    if (!stage) return;
    var imgs = [].slice.call(stage.querySelectorAll('img[data-ptx2-zoom]'));
    if (!imgs.length) return;
    var items = imgs.map(function (im) {
      return { small: im.currentSrc || im.src, big: im.getAttribute('data-ptx2-zoom'), alt: im.alt };
    });
    function current() { return Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth)); }
    function goTo(i) {
      var slide = stage.children[i];
      if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft });
    }
    function openAt(i, opener) {
      if (!lb) lb = buildViewer();
      items.forEach(function (it, j) { it.small = imgs[j].currentSrc || imgs[j].src; });
      lb.open(items, i, goTo, opener);
    }
    imgs.forEach(function (im, i) {
      im.addEventListener('click', function () { openAt(i, im); });
    });
    var btn = root.querySelector('[data-ptx2-zoombtn]');
    if (btn) btn.addEventListener('click', function () { openAt(current(), btn); });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-ptx2-buybox]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
